import { render, staticRenderFns } from "./ContentConfig.vue?vue&type=template&id=a3e6980c&scoped=true"
import script from "./ContentConfig.vue?vue&type=script&lang=js"
export * from "./ContentConfig.vue?vue&type=script&lang=js"
import style0 from "./ContentConfig.vue?vue&type=style&index=0&id=a3e6980c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e6980c",
  null
  
)

export default component.exports